module.exports = __webpack_public_path__ + "img/gallery-post-2.ad0855d3.jpg";